import {
  Exclude, Expose,
} from 'class-transformer';
import { Database } from 'shared/database.enum';

@Exclude()
export class CatalogueCount {
  @Expose()
  dbType: Database;

  @Expose()
  salesCount: number;

  @Expose()
  semenCount: number;
}
